// import Slider from "react-slick";
import AdditionFieldItem from "./AdditionFieldItem";
import FieldSeperator from "./FieldSeperator";

// const settings = {
//   dots: true,
//   infinite: false,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
// };

const AdditionalFields = ({ data, handleClose }) => {
  return (
    <div className={`additional-fields`} onClick={(e) => e.stopPropagation()}>
      <div className="page-header">
        <button
          type="button"
          className="btn btn-primary btn-sm float-right backArrow"
          onClick={handleClose}
        >
          <span></span>
        </button>
        <h3>Additional Fields</h3>
      </div>
      <div className="additional-fields-body">
        {/* <Slider {...settings} className="additional-fields-slider"> */}
        {_.toPairs(data ?? {}).map(([sectionKey, section]) => (
          <div
            className="additional-field-section"
            key={`additional-field-section-${sectionKey}`}
          >
            <FieldSeperator title={section.group_label} />
            <div className="additional-fields-items-container">
              {_.toPairs(section.fields ?? {}).map(([fieldKey, field]) => (
                <AdditionFieldItem
                  key={`additional-field-${fieldKey}`}
                  {...field}
                />
              ))}
            </div>
          </div>
        ))}
        {/* </Slider> */}
      </div>
    </div>
  );
};

export default AdditionalFields;
